import { Box, Divider, TextField } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import TableCont from './Table';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';

const apps = [
  {
    name: 'Accounting',
    subText: 'Watch videos, animations and quick tips on how to use the apps'
  },
  {
    name: 'Human resources',
    subText: 'Watch videos, animations and quick tips on how to use the apps'
  },
  {
    name: 'Payroll',
    subText: 'Watch videos, animations and quick tips on how to use the apps'
  },
  {
    name: 'Asset',
    subText: 'Watch videos, animations and quick tips on how to use the apps'
  },
  {
    name: 'Fleet',
    subText: 'Watch videos, animations and quick tips on how to use the apps'
  },
  {
    name: 'Doc Gen',
    subText: 'Watch videos, animations and quick tips on how to use the apps'
  },
  {
    name: 'My Edge',
    subText: 'Watch videos, animations and quick tips on how to use the apps'
  }
];

const faqs = [
  {
    name: 'How to make more money on bizedge',
    subText: 'Watch videos, animations and quick tips on how to use the apps'
  },
  {
    name: 'How to make more money on bizedge',
    subText: 'Watch videos, animations and quick tips on how to use the apps'
  },
  {
    name: 'How to make more money on bizedge',
    subText: 'Watch videos, animations and quick tips on how to use the apps'
  },
  {
    name: 'How to make more money on bizedge',
    subText: 'Watch videos, animations and quick tips on how to use the apps'
  }
];

const help = [
  {
    name: 'FAQS',
    subText: 'Find answers to frequently asked questions bout Bizedge'
  },
  {
    name: 'Contact Support',
    subText: `Can't find what you need? We are here to help you.`
  }
];

const Apps = ({ setStage }) => {
  return (
    <Apps.Wrapper>
      {apps.map((item) => (
        <>
          <TableCont
            key={item.name}
            name={item.name}
            subText={item.subText}
            handler={() => setStage(item.name)}
            bgColor='white'
            icon={true}
          />
          <Divider htmlColor='#E1E1E1' />
        </>
      ))}
    </Apps.Wrapper>
  );
};

export default Apps;

Apps.Wrapper = styled(Box)``;

export const GetHelp = ({ setStage }) => {
  return (
    <GetHelp.Wrapper>
      {help.map((item) => (
        <>
          <TableCont
            key={item.name}
            name={item.name}
            subText={item.subText}
            handler={() => setStage(item.name)}
            bgColor='white'
            icon={true}
          />
          <Divider htmlColor='#E1E1E1' />
        </>
      ))}
    </GetHelp.Wrapper>
  );
};
GetHelp.Wrapper = styled(Box)``;

export const Faqs = ({ setStage }) => {
  return (
    <GetHelp.Wrapper>
      <TextField
        style={{
          width: '100%'
        }}
        placeholder='Search for FAQs'
        color='secondary'
        variant='outlined'
        size='small'
        InputProps={{
          startAdornment: (
            <InputAdornment>
              <IconButton>
                <SearchIcon fontSize='small' />
              </IconButton>
            </InputAdornment>
          )
        }}
      />
      {faqs.map((item) => (
        <>
          <TableCont
            key={item.name}
            name={item.name}
            subText={item.subText}
            // handler={() => setStage(item.name)}
            bgColor='#FAFAFA'
            icon={false}
          />
        </>
      ))}
    </GetHelp.Wrapper>
  );
};
Faqs.Wrapper = styled(Box)``;
